import Datepicker from "../../shared/components/Datepicker/Datepicker";
import type { TechFormDateInputProps } from "../models/tech-form-page.models";
import {
  calendarDateForEditing,
  calendarDateForStorage,
  calendarDateFromTypedText,
} from "../utils/tech-form-calendar-date.utils";

export function TechFormDateInput({ name, value, error, className, wrapperClassName, onChange }: TechFormDateInputProps) {
  return (
    <div>
      <Datepicker
        id={name}
        name={name}
        selected={calendarDateForEditing(value)}
        error={error}
        strictParsing
        onChange={(date) => onChange(calendarDateForStorage(date))}
        onChangeRaw={(event) => {
          const raw = (event?.target as HTMLInputElement | undefined)?.value;
          if (raw !== undefined) onChange(calendarDateFromTypedText(raw));
        }}
        ariaDescribedBy={error ? name + "-error" : undefined}
        className={className}
        wrapperClassName={wrapperClassName}
      />
      {error && (
        <p id={name + "-error"} className="mt-1 text-xs text-red-600">
          {error}
        </p>
      )}
    </div>
  );
}
